import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { MyHealthIcon } from "../../../../assets/icons";

const NoQuiz = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <img src={MyHealthIcon} alt="my-health-icon" />
      <Typography variant="h2">Não há nada para ver por aqui!</Typography>
    </Box>
  );
}

export default NoQuiz;

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    container: {
      minHeight: 340,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',

      '& h2': {
        fontSize: theme.typography.pxToRem(20),
        fontWeight: theme.typography.fontWeightBold,
      },

      '& p': {
        width: '70%',
        color: theme.palette.text.secondary,
        textAlign: 'center'
      }
    },
    button: {
      marginTop: theme.spacing(3),
      padding: theme.spacing(0.5, 5),
      fontSize: 16,
      borderRadius: 35,
      textTransform: "initial",
    }
  }))